<template>
    <nav class="menu-container">

      <RouterLink
        :exact="item.exact"
        v-for="item in items"
        :key="item.link"
        :to="{ name: item.name }"
        active-class="selected"
        exact-active-class=""
      >
        <div class="icon">
          <Icon :type="item.icon" />
        </div>
        <span>{{ item.title }}</span>
      </RouterLink>
      荔林站<br>
站点介绍<br>
荔林站位于东滨路与南新路交汇处，东北侧为阳光科创中心，北侧及西北侧分别为荔源大厦和豪盛商务中心，西南侧依次为荔园商务大厦。车站设有6个出入口，分别为A、B（B1/B2）、C、D、E出入口。车站以白色为主色调,与全线标准统一材料、规格、安装形式，呼应和谐主题，整个空间协调统一。该站为地下站。<br><br>
运营时刻表(工作日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:25	00:04	9号线	3分50秒	5分55秒<br>
文锦	06:25	23:05	9号线	3分50秒	5分55秒<br><br>
运营时刻表(休息日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:26	00:04	9号线	4分25秒	5分55秒<br>
文锦	06:25	23:05	9号线	4分25秒	5分55秒<br><br>
运营时刻表(节假日)<br>
行驶方向	首班车	末班车	所属线路	高峰间隔	平峰间隔<br>
前湾	06:25	01:04	9号线	4分钟	5分55秒<br>
文锦	06:25	00:05	9号线	4分钟	5分55秒<br><br>
<br>
站点出口信息<br><br>
A出入口:<br>
东滨路南侧（西）、荔庭园、国家税务总局深圳市前海税务局、立桥城购物中心<br><br>
B出入口:<br>
东滨路南侧（东）、城市山林<br><br>
C出入口:<br>
东滨路北侧（东）、华联城市中心<br><br>
E出入口:<br>
东滨路北侧（西）、瑞景华庭、立桥城购物中心<br><br>
D出入口:<br>
南新路西侧、南山村<br><br>
公交换乘信息<br><br>
A出入口:<br>
公交站名： 荔林站<br>
M372、M418、M467、M484、M507、M347、81、122、229、369、高峰专线150、234<br><br>
B出入口:<br>
公交站名： 荔林站<br>
122、229、369、M372、M400、M418、M467、M484、M507<br><br>
C出入口:<br>
公交站名： 荔林站<br>
74、122、229、369、M242、M372、M400、M418、M467、M484、M507,高峰专线150、22、74、81、M242、M347、234<br><br>
D出入口:<br>
公交站名： 荔林站<br>
22、81、M347、M400、234<br><br>
E出入口:<br>
公交站名： 荔林站<br>
81、122、229、369、M372、M418、M467、M347、 M484、M507、高峰专线150、234<br>
  </nav>
  </template>

  <script>
  // import Icon from "@/components/Icon";
  export default {
    components: {
      // Icon,
    },
    data() {
      return {
        items: [
          {
            name: "jiuhaoxian",
            title: "9号线",
            // icon: "chat",
            exact: true,
          },
        ],
      };
    },
  };
  </script>

  <style scoped lang="less">
  @import "~@/styles/var.less";
  .menu-container {
    color: @words;
    margin: 24px 0;
    a {
      &.selected {
        background: darken(@words, 3%);
      }
      padding: 0 50px;
      display: block;
      display: flex;
      align-items: center;
      height: 45px;
      // .icon {
      //   width: 24px;
      // }
      &:hover {
        color: rgb(50, 95, 227);
      }
    }
  }
  </style>